import { Select, Tag, Checkbox } from "antd";
import React, { useEffect, useState } from "react";

import ajaxUtil from "../../util/ajax";

const { DOMAIN_CURRENT, ajaxv2, ajax } = ajaxUtil;

const { Option } = Select;

// 缓存数据，避免多次请求什么的
window.__cached_gallery_list = null;
export default function MultiGallerySelect(props) {
  const { value, onChange, mode } = props;
  const [list, setList] = useState([]);

  const isMultiple = mode != "single";

  const normalizeSelectedKeys = (val) => {
    if (val === null || typeof val === "undefined") {
      return [];
    }
    if (val instanceof Array) {
      return val
        .map((it) => {
          if (it && typeof it === "object") {
            return `${it.key || it.value || ""}`;
          }
          return `${it}`;
        })
        .filter((it) => !!it);
    }
    return [`${val}`];
  };

  const getList = async function () {
    const gallery = window.decorateGetGallery();
    const res =
      window.__cached_gallery_list ||
      (await ajaxv2({
        url: DOMAIN_CURRENT + `/api/v2/gallery/${gallery.id}/childlist`,
      }));
    window.__cached_gallery_list = res;
    let list = (res || []).map((it) => {
      return {
        key: it.id,
        name: it.name,
        img_count: it.img_count,
        check: it.check,
        privacy: it.privacy,
      };
    });
    if (list.length <= 0) {
      list.unshift({
        key: gallery.id,
        name: gallery.name,
        img_count: gallery.img_count,
        check: gallery.check,
        privacy: gallery.privacy,
      });
    }

    setList(list);
  };

  useEffect(() => {
    getList();
    return () => {
      window.__cached_gallery_list = null;
    };
  }, []);

  const renderGalleryName = (one) => {
    return (
      <React.Fragment>
        {one.check ? <Tag color="red">审核</Tag> : null}
        {one.privacy != "normal" ? <Tag color="orange">私密</Tag> : null}
        <Tag>{one.img_count}张</Tag>
        {one.name}
      </React.Fragment>
    );
  };

  const allKeys = (list || []).map((one) => `${one.key}`);
  const selectedKeys = normalizeSelectedKeys(value);
  const isAllSelected =
    isMultiple &&
    allKeys.length > 0 &&
    allKeys.every((k) => selectedKeys.includes(k));
  const isIndeterminate =
    isMultiple && selectedKeys.length > 0 && !isAllSelected;

  const toggleAll = (e) => {
    if (!isMultiple) {
      return;
    }
    if (e && e.target && e.target.checked) {
      onChange && onChange(allKeys);
    } else {
      onChange && onChange([]);
    }
  };

  const clearAll = () => {
    if (!isMultiple) {
      return;
    }
    onChange && onChange([]);
  };

  return (
    <Select
      mode={isMultiple ? "tags" : undefined}
      style={{ width: props.width }}
      value={value}
      onChange={onChange}
      tokenSeparators={[","]}
      dropdownRender={(menu) => {
        if (!isMultiple) {
          return menu;
        }
        return (
          <div>
            <div
              onMouseDown={(e) => e.preventDefault()}
              style={{
                padding: "6px 12px",
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Checkbox
                indeterminate={isIndeterminate}
                checked={isAllSelected}
                onChange={(e) => {
                  console.log(e);
                  toggleAll(e);
                }}
              >
                全选
              </Checkbox>

              <span
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  clearAll();
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                清空
              </span>
            </div>
            {menu}
          </div>
        );
      }}
    >
      {list.map((one) => (
        <Option key={`${one.key}`}>{renderGalleryName(one)}</Option>
      ))}
    </Select>
  );
}


// WEBPACK FOOTER //
// ./src/components/Select/MultiGallerySelect.js